export const tabVapor = (theme, variant) => {
  return {
    "&.MuiTab-root": {
      ...theme.typography["titleMedium"],
      color: theme.palette.primary.textSubduedColor,
      fontWeight: 600,
      paddingLeft: 24,
      paddingRight: variant === "activeStep" ? 48 : 24,
      borderBottom: "4px solid transparent",
      clipPath:
        variant === "activeStep" &&
        "polygon(0% 0%, calc(100% - 24px) 0%, 100% 50%, calc(100% - 24px) 100%, 0% 100%)",
      opacity: "1"
    },
    "&.MuiTab-root:hover": {
      ...theme.typography["titleMedium"],
      background: theme.palette.primary.interactiveDefault,
      color: theme.palette.primary.baseWhiteColor,
      fontWeight: 600
    },
    "&.MuiTab-root.Mui-selected": {
      ...theme.typography["titleMedium"],
      color: theme.palette.primary.primary60Color,
      background: theme.palette.primary.background,
      borderBottom: "4px solid " + theme.palette.primary.borderActive
    },
    "&.MuiTab-root.Mui-disabled": {
      cursor: "not-allowed",
      pointerEvents: "all !important",
      color: theme.palette.primary.textDisabledColor
    },
    "&.MuiTab-root.Mui-disabled:hover": {
      background: "transparent"
    },
    "&.MuiTab-root div .svg-inline--fa": {
      fontSize: 16
    },
    "&.MuiTab-root div .MuiBadge-root .MuiBadge-badge": {
      position: "relative",
      top: 11,
      right: 10
    }
  };
};
